import React, { PureComponent } from 'react';
import { Close } from '@mui/icons-material';
import { connect } from 'react-redux';
import { Dialog, IconButton, LinearProgress } from '@mui/material';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import { IAppState } from '../../../state/reducers';
import { reset, init } from '../../../state/exchange/activeUsers';
import {
  DialogHeader,
  DialogHeaderTitle,
  DialogContentContainer,
} from '../../Shared/styles/dialog';
import { ProgressContainer, UserContainer, UserListContainer } from './styles';

class ContactInfoDialog extends PureComponent<IProps> {
  renderUserList = () => {
    const { users } = this.props;

    return users.map((user) => (
      <UserContainer key={user.id}>
        {user.firstName} {user.lastName} - {user.email}
      </UserContainer>
    ));
  };

  renderDialogContent = () => {
    const {
      isLoaded,
      reset,
    } = this.props;

    return (
      <>
        <DialogHeader
          data-auto="ContactInfoModal"
        >
          <DialogHeaderTitle style={{ marginLeft: '48px' }}>
            Active Users
          </DialogHeaderTitle>
          <IconButton data-auto="CloseContactInfoModal" onClick={reset} size="large">
            <Close />
          </IconButton>
        </DialogHeader>
        <ProgressContainer>
          {!isLoaded && <LinearProgress />}
        </ProgressContainer>
        <DialogContentContainer>
          <UserListContainer>
            {this.renderUserList()}
          </UserListContainer>
        </DialogContentContainer>
      </>
    );
  };

  render() {
    const {
      isOpen,
      reset,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={reset}
        fullWidth
        maxWidth="md"
      >
        {this.renderDialogContent()}
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.activeUsers.isOpen,
  isLoaded: state.exchange.activeUsers.isLoaded,
  users: state.exchange.activeUsers.users,
});

const mapDispatchToProps: IDispatchProps = {
  reset,
  init,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactInfoDialog);
